/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ConfirmedActionItem } from "./ConfirmedActionItem";
import {
  ConfirmedActionItemFromJSON,
  ConfirmedActionItemFromJSONTyped,
  ConfirmedActionItemToJSON,
  ConfirmedActionItemToJSONTyped,
} from "./ConfirmedActionItem";

/**
 *
 * @export
 * @interface LogSalesCallJamieMeetingInput
 */
export interface LogSalesCallJamieMeetingInput {
  /**
   *
   * @type {string}
   * @memberof LogSalesCallJamieMeetingInput
   */
  jamieMeetingId: string;
  /**
   *
   * @type {Array<ConfirmedActionItem>}
   * @memberof LogSalesCallJamieMeetingInput
   */
  actionItems: Array<ConfirmedActionItem>;
}

/**
 * Check if a given object implements the LogSalesCallJamieMeetingInput interface.
 */
export function instanceOfLogSalesCallJamieMeetingInput(
  value: object,
): value is LogSalesCallJamieMeetingInput {
  if (!("jamieMeetingId" in value) || value["jamieMeetingId"] === undefined)
    return false;
  if (!("actionItems" in value) || value["actionItems"] === undefined)
    return false;
  return true;
}

export function LogSalesCallJamieMeetingInputFromJSON(
  json: any,
): LogSalesCallJamieMeetingInput {
  return LogSalesCallJamieMeetingInputFromJSONTyped(json, false);
}

export function LogSalesCallJamieMeetingInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LogSalesCallJamieMeetingInput {
  if (json == null) {
    return json;
  }
  return {
    jamieMeetingId: json["jamieMeetingId"],
    actionItems: (json["actionItems"] as Array<any>).map(
      ConfirmedActionItemFromJSON,
    ),
  };
}

export function LogSalesCallJamieMeetingInputToJSON(
  json: any,
): LogSalesCallJamieMeetingInput {
  return LogSalesCallJamieMeetingInputToJSONTyped(json, false);
}

export function LogSalesCallJamieMeetingInputToJSONTyped(
  value?: LogSalesCallJamieMeetingInput | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    jamieMeetingId: value["jamieMeetingId"],
    actionItems: (value["actionItems"] as Array<any>).map(
      ConfirmedActionItemToJSON,
    ),
  };
}
